import { dew as _SchemaDew } from "../../Schema";
import { dew as _createIdentitySchemaCreatorDew } from "../../utils/createIdentitySchemaCreator";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.unknown = void 0;
  const Schema_1 = _SchemaDew();
  const createIdentitySchemaCreator_1 = _createIdentitySchemaCreatorDew();
  exports.unknown = (0, createIdentitySchemaCreator_1.createIdentitySchemaCreator)(Schema_1.SchemaType.UNKNOWN, value => ({
    ok: true,
    value
  }));
  return exports;
}